// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"bd150aae","805":"bd150aae"}[chunkId] + ".chunk.css";
};